module.exports = __webpack_public_path__ + "static/35-seat-midi-coach-hire-interior-a2cd93c0e547dd65ff1a512cd4319264.jpg";